// src/pages/Defesa/DefesaPage.jsx
import React from 'react';
import DefesaList from '../../components/Defesa/DefesaList';
import { Link } from 'react-router-dom';

const DefesaPage = () => {
  return (
    <div className="p-6 space-y-6">
      <h1 className="text-2xl font-bold">Gestão de Defesas</h1>
      <Link to="/defesas/agendar" className="text-blue-500">Agendar Nova Defesa</Link>
      <DefesaList />
    </div>
  );
};

export default DefesaPage;
